import { Flex, Button as ChakraButton, Divider } from '@chakra-ui/react';
import BEIcon from '@molecules/BEIcon';
import BEImageList from '@molecules/BEImageList';
import BEPills from '@molecules/BEPills';
import Button from '@molecules/Button';
import Card from '@molecules/Card';
import Text from '@molecules/Text';
import { useState } from 'react';
import RatePlanCard from '../RatePlan/desktop';
import {
  StyledRoomCardContainer,
  StyledRoomCardGalleryContainer,
  StyledRoomInfoContainer,
  StyledImageMask,
  StyledMark,
  StyledFooter,
} from './StyledRoomDetailCard';
import { useModal } from '@molecules/BEOffScreen';
import Gallery from '@view/components/Modals/Gallery';
import AccommodationDetails from '@view/components/Modals/AccommodationDetails';
import Accommodation from '@data/models/Accommodation';
import { ThemeColors } from '@theme/foundations/colors';
import { useTranslation } from 'react-i18next';
interface RoomCardAccommodation {
  accommodation: Accommodation;
  packages: Accommodation[] | [];
}

const RoomDetailCard = ({ accommodation, packages }: RoomCardAccommodation) => {
  const { images, description, available } = accommodation;
  const isAvailable = available > 0;
  const { t } = useTranslation();

  const [expanded, setExpand] = useState(true);
  const onClickExpand = () => {
    setExpand(!expanded);
  };

  const galleryModal = useModal(Gallery, {});
  const accommodationDetailsModal = useModal(AccommodationDetails, {});

  const handleClickDetails = () => {
    galleryModal.close();
    accommodationDetailsModal.open({
      accommodation,
      handleClickImage,
    });
  };
  const handleOpenGalleryModal = (index?: number) => {
    galleryModal.open({
      index,
      images,
      handleClickDetails,
    });
  };

  const handleClickImage = (imgIndex: number) => {
    accommodationDetailsModal.close();
    galleryModal.open({
      index: imgIndex,
      images,
      handleClickDetails,
    });
  };
  const openAccommodationDetails = () => {
    accommodationDetailsModal.open({
      accommodation,
      handleClickImage,
    });
  };

  return (
    <Card padding="0" bgColor={isAvailable ? 'white' : ThemeColors.neutral[50]}>
      <StyledRoomCardContainer>
        <StyledRoomCardGalleryContainer>
          <BEImageList
            images={images.map((image) => image.thumb)}
            responsive={{
              xs: {
                itemHeight: 260,
                multiplier: 0.55,
              },
              sm: {
                itemHeight: 260,
                multiplier: 0.55,
              },
              md: {
                itemHeight: 260,
                multiplier: 0.55,
              },
              lg: {
                itemHeight: 260,
                multiplier: 0.55,
              },
              xl: {
                itemHeight: 260,
                multiplier: 0.55,
              },
              '2xl': {
                itemHeight: 260,
                multiplier: 0.55,
              },
            }}
            onClickItem={handleOpenGalleryModal}
          />
          {!isAvailable && (
            <>
              <StyledImageMask />
              <StyledMark size="md" weight="500" color="neutral" darkness="50">
                {t('none-available')}
              </StyledMark>
            </>
          )}
        </StyledRoomCardGalleryContainer>
        <StyledRoomInfoContainer>
          <Text
            size="xl"
            weight="600"
            color={isAvailable ? 'black' : 'neutral'}
            darkness={isAvailable ? '500' : '600'}
          >
            {accommodation.name}
          </Text>
          <Flex gap="12px" mt={3}>
            {accommodation.adults > 0 && (
              <BEPills iconRight="user">{accommodation.adults}</BEPills>
            )}
            {accommodation.kids > 0 && (
              <BEPills iconRight="child-reaching">{accommodation.kids}</BEPills>
            )}
          </Flex>
          <Text mt="24px" mb="4px" html={description} maxLines={5} />
          <Button
            className="text-underline"
            variant="link"
            color="primary"
            paddingY={1}
            onClick={openAccommodationDetails}
          >
            View Details
          </Button>
        </StyledRoomInfoContainer>
      </StyledRoomCardContainer>
      {(packages.length <= 2 || expanded) &&
        isAvailable &&
        packages.map((acc, index) => (
          <div key={index}>
            <Divider />
            <RatePlanCard {...acc} showThumb={packages.length > 1} />
          </div>
        ))}

      {
        // !isAvailable ? ( // TODO: - this one is V3.1
        //   <StyledFooter>
        //     <Flex gap="16px" flexDirection='column' justifyContent='center' alignItems='center' paddingY='8px'>
        //       <Flex flexDirection={isMobile ? 'column' : 'row'} alignItems='center' gap={isMobile ? '0' : '4px'}>
        //         <Text weight="500">
        //           Selected dates are not available.
        //         </Text>
        //         <Text weight="400">
        //           Check the calendar to find available dates
        //         </Text>
        //       </Flex>
        //       <DatePicker size='md' />
        //     </Flex>
        //   </StyledFooter>
        // ) :
        packages.length > 2 ? (
          <StyledFooter>
            <ChakraButton
              className="book-button"
              rightIcon={
                <BEIcon name={expanded ? 'angle-up' : 'angle-down'} size="sm" />
              }
              h="40px"
              border="2px solid #99A1AF"
              borderRadius="24px"
              backgroundColor="white"
              onClick={onClickExpand}
            >
              {expanded ? 'Hide Rates' : 'Show Rates'}
            </ChakraButton>
          </StyledFooter>
        ) : null
      }
    </Card>
  );
};

export default RoomDetailCard;
